import { DigitalAdExchangeCatalog, DOOHAdExchangeCatalog } from 'sonata-static-storage/lib/samples/adExchanges.samples';

import type { CampaignFamilyEnum } from 'sonata-static-storage/lib/schemas/campaign/campaign.schema';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';

export function getAllowedAdExchangeCodes(user: UserInterface, familyType?: CampaignFamilyEnum): string[] {
  const catalog = familyType === 'dooh' ? DOOHAdExchangeCatalog : DigitalAdExchangeCatalog;
  const allCodes = Object.values(catalog).map(ad => ad.code);
  const permittedCodes = user.customPermissions?.adExchanges ?? [];

  return permittedCodes.length === 0 ? allCodes : permittedCodes;
}
